import React, { useMemo } from "react";
import "./BlobBackground.scss";

const BLOB_COUNT = 3;

const BlobBackground = () => {
  const blobs = useMemo(() => {
    return Array.from({ length: BLOB_COUNT }, (_, i) => ({
      id: i + 1,
      delay: -(Math.random() * 20 + 5).toFixed(1),
    }));
  }, []);

  return (
    <div className="blob-bg" aria-hidden="true">
      {blobs.map((blob) => (
        <div
          key={blob.id}
          className={`blob blob-${blob.id}`}
          style={{ animationDelay: `${blob.delay}s` }}
        />
      ))}
      <div className="blob-bg__overlay" />
    </div>
  );
};

export { BlobBackground };
